import React, { useEffect, useState } from 'react';
import { facilityAPI } from '../../lib/api';
import { FileText, Loader2, X } from 'lucide-react';

// Lädt ein Facility-Foto/Dokument als Blob (Auth-Header nötig) und zeigt es an.
// Bilder als Thumbnail, PDFs als Icon-Kachel. Klick öffnet Vollansicht.
export const PhotoThumb = ({ photo, onDelete, size = 'h-20 w-20', fetcher }) => {
  const [url, setUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const isPdf = (photo.content_type || '').includes('pdf');
  const load = fetcher || facilityAPI.photoBlob;

  useEffect(() => {
    let revoked = null;
    let active = true;
    setLoading(true);
    load(photo.id)
      .then((res) => {
        if (!active) return;
        const objUrl = window.URL.createObjectURL(res.data);
        revoked = objUrl;
        setUrl(objUrl);
      })
      .catch(() => {})
      .finally(() => active && setLoading(false));
    return () => { active = false; if (revoked) window.URL.revokeObjectURL(revoked); };
  }, [photo.id]); // eslint-disable-line

  const open = () => { if (url) window.open(url, '_blank'); };

  return (
    <div className="relative group" data-testid={`facility-photo-${photo.id}`}>
      <button
        type="button"
        onClick={open}
        className={`${size} rounded-lg border border-border/60 overflow-hidden bg-secondary/40 flex items-center justify-center hover:ring-2 hover:ring-primary/40 transition-all`}
        title={photo.original_filename || 'Öffnen'}
      >
        {loading ? (
          <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" />
        ) : isPdf ? (
          <FileText className="h-7 w-7 text-primary" />
        ) : url ? (
          <img src={url} alt={photo.original_filename || ''} className="h-full w-full object-cover" />
        ) : (
          <X className="h-5 w-5 text-muted-foreground" />
        )}
      </button>
      {onDelete && (
        <button
          type="button"
          onClick={() => onDelete(photo)}
          className="absolute -top-2 -right-2 bg-destructive text-destructive-foreground rounded-full p-0.5 opacity-0 group-hover:opacity-100 transition-opacity"
          data-testid={`facility-photo-delete-${photo.id}`}
          title="Entfernen"
        >
          <X className="h-3 w-3" />
        </button>
      )}
    </div>
  );
};
